import type { InvoiceStatus } from '../billingTypes';
import { formatCents } from '../types';
import { formatUtcDate } from '../formatDate';

export { formatCents, formatUtcDate };

/** "Visa ending 4242" / "Bank account ending 6789". Never more than the last four digits the server supplied. */
export function paymentMethodLabel(method: { type: string; brand: string | null; last4: string | null } | null): string {
  if (!method) return 'No payment method on file';
  const kind = method.type === 'UsBankAccount' ? 'Bank account' : method.brand ?? 'Card';
  return method.last4 ? `${kind} ending ${method.last4}` : kind;
}

/** Plain-language invoice status. The text is the signal; any colour is reinforcement only. */
export function invoiceStatusLabel(status: InvoiceStatus): string {
  switch (status) {
    case 'Paid': return 'Paid';
    case 'Open': return 'Open (unpaid)';
    case 'Void': return 'Void';
    case 'Uncollectible': return 'Could not be collected';
    case 'Draft': return 'Draft';
    default: return status;
  }
}
